import api from './api';

/**
 * Projection Comparison Service
 * Handles API calls for projection vs. actual billing comparison
 */

export const projectionComparisonService = {
  /**
   * Generate projections for a given month range
   * @param {string} projectCode - Project code or 'ALL' for all projects
   * @param {string} startMonth - Start month in YYYY-MM format
   * @param {string} endMonth - End month in YYYY-MM format
   */
  generateProjections: async (projectCode, startMonth, endMonth) => {
    const response = await api.post('/projection-comparison/generate', {
      project_code: projectCode,
      start_month: startMonth,
      end_month: endMonth,
    });
    return response.data;
  },

  /**
   * Get comparison report
   * @param {string|string[]} projectCodes - Project code(s) or 'ALL' for all projects
   * @param {string} startMonth - Start month in YYYY-MM format
   * @param {string} endMonth - End month in YYYY-MM format
   * @param {string} viewType - 'monthly', 'quarterly', or 'yearly'
   * @param {string} reportType - 'comparison' or 'projection_only'
   * @param {string} viewLevel - 'employee' or 'project'
   */
  getReport: async (projectCodes, startMonth, endMonth, viewType = 'monthly', reportType = 'comparison', viewLevel = 'employee') => {
    const payload = {
      start_month: startMonth,
      end_month: endMonth,
      view_type: viewType,
      report_type: reportType,
      view_level: viewLevel,
    };

    // Handle array or single project code
    if (Array.isArray(projectCodes)) {
      payload.project_codes = projectCodes.map(p => p.project_code || p);
    } else if (projectCodes && projectCodes.project_code) {
      payload.project_code = projectCodes.project_code;
    } else {
      payload.project_code = projectCodes || 'ALL';
    }

    const response = await api.post('/projection-comparison', payload);
    return response.data;
  },

  /**
   * Export comparison report
   * @param {string|string[]} projectCodes - Project code(s) or 'ALL' for all projects
   * @param {string} startMonth - Start month in YYYY-MM format
   * @param {string} endMonth - End month in YYYY-MM format
   * @param {string} viewType - 'monthly', 'quarterly', or 'yearly'
   * @param {string} reportType - 'comparison' or 'projection_only'
   * @param {string} viewLevel - 'employee' or 'project'
   * @param {string} format - 'excel' or 'pdf'
   */
  exportReport: async (projectCodes, startMonth, endMonth, viewType, reportType, viewLevel, format) => {
    const payload = {
      start_month: startMonth,
      end_month: endMonth,
      view_type: viewType,
      report_type: reportType,
      view_level: viewLevel,
      format: format,
    };

    if (Array.isArray(projectCodes)) {
      payload.project_codes = projectCodes.map(p => p.project_code || p);
    } else if (projectCodes && projectCodes.project_code) {
      payload.project_code = projectCodes.project_code;
    } else {
      payload.project_code = projectCodes || 'ALL';
    }

    const response = await api.post('/projection-comparison/export', payload);
    return response.data;
  },
};

export default projectionComparisonService;
